const DEFAULT_WHATSAPP_NUMBER = '212604401740';

export const WHATSAPP_DISPLAY_NUMBER = '+212 6 04 40 17 40';

export const buildWhatsAppUrl = (message: string) => {
    const phone = import.meta.env.VITE_WHATSAPP_NUMBER || DEFAULT_WHATSAPP_NUMBER;
    const normalizedPhone = phone.replace(/\D/g, '');

    return `https://wa.me/${normalizedPhone}?text=${encodeURIComponent(message)}`;
};
